import { AfterViewInit, Component, EventEmitter, Input, Output } from '@angular/core';
import { promiseWithCatch } from 'src/app/common/app.helpers';
import { SocialInitiativeChange } from 'src/app/components/shared/social-initiative/social-initiative-change.abstract';
import { Project, UpdateProjectRequest } from '../../../../../swagger-api';
import { ProjectFormData } from '../../../projects.interfaces';

@Component({
  selector: 'app-update-project',
  templateUrl: './update-project.component.html',
  styleUrls: ['./update-project.component.scss'],
})
export class UpdateProjectComponent extends SocialInitiativeChange<ProjectFormData> implements AfterViewInit {
  @Input({ required: true }) public project: Project;

  @Output() public removeProject: EventEmitter<string> = new EventEmitter<string>();
  @Output() public updateProject: EventEmitter<UpdateProjectRequest> = new EventEmitter<UpdateProjectRequest>();

  public ngAfterViewInit(): void {
    this.subscribeToControlValueChanges();
  }

  public onCancel(): void {
    promiseWithCatch(this.router.navigateByUrl(`${this.ProjectLinks.LINK_PROJECTS_VIEW}/${this.project.entity_id}`));
  }

  public onRemoveProject(): void {
    this.removeProject.emit(this.project.entity_id);
  }

  protected changeEntity(data: ProjectFormData): void {
    const _data: UpdateProjectRequest = {
      ...data,
      disease_ids: data.diseases,
      specialty_ids: data.specialities,
    } as UpdateProjectRequest;

    delete _data['specialities'];
    delete _data['diseases'];

    this.updateProject.emit(_data);
  }
}
